@app.service 'ShopifyService', ($state, localStorageService, $resource, $q, authenticationService, $timeout) ->

  @setHeaderParams = (currentUser) =>
    if currentUser
      userToken = localStorageService.get('user.token')
      @headerParams = { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }
    else
      @headerParams = null

    @resource = $resource "#{csConfig.chefstepsEndpoint}/api/v0/shopping/products/:id", { id: '@id' },
      'index':
        method: 'GET'
        isArray: true
        headers: @headerParams
      'show':
        method: 'GET'
        isArray: false
        headers: @headerParams

  @loadData = (currentUser) =>
    @setHeaderParams(currentUser)
    deferred = $q.defer()

    if @products
      deferred.resolve @products
    else
      loadDataSuccess = (data) =>
        @products = data
        deferred.resolve @products
      loadDataError = (error) ->
        Rollbar.error("ShopifyService - error while calling loadData at url: #{$state.current.url}, error: #{JSON.stringify(error)}")
        if error.status == 403
          $state.go '/logout'
        deferred.reject error

      @resource.index(loadDataSuccess, loadDataError)

    deferred.promise

  @variantForSku = (sku) =>
    if @products && @products.length > 0
      product_sku = sku.split('-')[0]
      product = _.find @products, (product) -> product.sku == product_sku
      _.find product.variants, (variant) -> variant.sku == sku
    else
      Rollbar.error("ShopifyButton - @products not set for button at url: #{$state.current.url}, products: #{@products}, sku: #{sku}")

  @logout = ->
    # Absolutely gruesome hack to get us logged out of shopify using a hidden iframe.
    # Note that this frame actually gets an error! But still logs us out. So.. yay?
    $('body').append("<iframe class='shopify-killer' src='#{csConfig.shopifyEndpoint}/account/logout' style='position: absolute; left: -10000px;'>")
    $timeout ( ->
      $('.shopify-killer').remove()
    ), 3000

  this
